import api from "../../system/api";

// Personal notification settings, push status and scheduled reports (backend: src/api/notification in zofino-strapi).

const data = (response) => response?.data?.data;

export const notificationApi = {
    getSettings: async () => data(await api.get("/notifications/settings")),
    saveSettings: async (preference) => data(await api.put("/notifications/settings", {data: preference})),
    pause: async (until) => data(await api.put("/notifications/pause", {data: {until}})),
    testPush: async () => data(await api.post("/notifications/push-test", {data: {}})),
    pushStatus: async () => data(await api.get("/notifications/push-status")),
    pushKey: async () => data(await api.get("/notifications/push-key", {suppressGlobalErrorHandler: true})),
    // scheduled reports belong to one workspace: the one the user is in
    getReports: async (workspace) => data(await api.get("/notifications/reports", {headers: {workspace}})),
    createReport: async (report, workspace) => data(await api.post("/notifications/reports", {data: {...report, workspace}}, {headers: {workspace}})),
    updateReport: async (documentId, report) => data(await api.put(`/notifications/reports/${documentId}`, {data: report})),
    deleteReport: async (documentId) => data(await api.delete(`/notifications/reports/${documentId}`)),
    sendReport: async (documentId) => data(await api.post(`/notifications/reports/${documentId}/send`, {data: {}})),
};
